import React, {useState, useEffect} from "react";
import CardPanel from "../../components/Custom Components/card-panel/card-panel";
import CardPanelHeader from "../../components/Custom Components/card-panel/card-panel-header";
import CardPanelBody from "../../components/Custom Components/card-panel/card-panel-body";
import AllocationCard from "../../components/Custom Components/allocation-card/allocation-card";
import "./new-dashboard.scss";
import { getUser } from "../../services/authService";
import StatisticsCard from "../../components/Custom Components/statistics-card/statistics-card";
import AsyncSelectField from "../../components/common/inputs/AsyncSelectField";
import { requestCountries } from "../../services/dataService";
import Tooltips from "../../components/Custom Components/tooltip";
import { getCarrierAllocation, getContainerCount } from "../../services/dataService";
import moment from "moment";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import noDataAvailable from "../../assets/img/no_data_found_dashboard.png"
import store from "../../store/Store";
import { filter } from "lodash";

function NewDashboard() {
	const [shipmentData, setShipmentData] = useState({
		country: "United States"
	  });
    const [value,setvalue] = useState("") 

	// const [loading, setLoading] = useState(false);
	const [carrierMonth, setCarrierMonth] = useState(moment().format("YYYY-MM"));
	const [containerCountMonth, setContainerCountMonth] = useState(moment().format("YYYY-MM"));
	const [carrierAllocationData, setCarrierAllocationData] = useState([]);
	const [containerCountData, setContainerCountData] = useState([]);
  const [allocationNoData, setAllocationNoData] = useState(false)
  const [allocationLoader, setAllocationLoader] = useState(false)
  const [containerCountNoData, setContainerCountNoData] = useState(false)
  const [containerCountLoader, setContainerCountLoader] = useState(false)
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const user = getUser();

  useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

  useEffect(() => {
		if (filter(userData, { MenuName: "Dashboard", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Dashboard", View: 1 })
			);
		}
	}, [userData]);

  var allowToEdit = filter(filteredUserAccessData,{Edit:1}).length > 0

	useEffect(() => {
		async function getCarrierAllocationData() {
			try {
        if(carrierMonth && shipmentData.country){
          setAllocationLoader(true);
          const response = await getCarrierAllocation(`${moment(carrierMonth).format("MMM-YY")}`, `${shipmentData.country}`);
          setCarrierAllocationData(response.data);
        }
        setAllocationNoData(false);
        setAllocationLoader(false);
			} catch (error) {
        if(error.response.data.StatusCode===404){
          setAllocationNoData(true);
        }
        setAllocationLoader(false)
				setCarrierAllocationData([]);
			}
		}
		getCarrierAllocationData();
	}, [carrierMonth, shipmentData]);

  useEffect(()=>{
    async function getContainerCountData() {
      try {
        setContainerCountLoader(true)
        const response = await getContainerCount(`${moment(containerCountMonth).format("MMM-YY")}`)
        setContainerCountData(response.data);
        setContainerCountLoader(false)
        setContainerCountNoData(false)
      } catch (error) {
        if(error.response.data.StatusCode===404){
          setContainerCountNoData(true)
        }
        setContainerCountLoader(false)
        setContainerCountData([]);
				toast.error(
					`Container count records not found for ${moment(containerCountMonth).format("MMM-YYYY")}`
				);
      }
    }
    getContainerCountData()
  },[containerCountMonth])

  function changeHandler(e) {
    setCarrierMonth((e.target.value))
  }
  const tractorObj = {
    DataOf: "Tractor",
  };
  const aggObj = {
    DataOf: "Aggregate",
  }
  const fiveMObj = {
    DataOf: "5M",
  }

	return (
    <div className="new-dashboard-container">
      <h1 className="page-title">Dashboard</h1>
      <h2 className="user-name">Welcome back {user.first_name}!!</h2>
      <div className="new-dashboard-top">
        <CardPanel>
          <CardPanelHeader title="Monthly Carrier Allocation Statistics" customClass = "action-area">
            <input
              type="month"
              value={carrierMonth}
              name="month"
              className="newDashboard_monthClass"
              onChange={changeHandler}
            />
            <Tooltips content={shipmentData.country} direction="down">
                  <AsyncSelectField
                    dbKey={"Countryname"}
                    lableKey={"Countryname"}
                    value={{ Countryname: shipmentData.country }}
                    onChange={(option) =>
                      setShipmentData({
                        ...shipmentData,
                        country: option.Countryname,
                      })
                    }
                    getOptionsAPI={requestCountries}
                    setvalue={setvalue}
                  />
            </Tooltips>
          </CardPanelHeader>
          {!allocationLoader && <CardPanelBody>
            <div className="dashboard-row">
              {
                carrierAllocationData.map((item)=>{
                  return(
                    <AllocationCard item={item} key={item.Carrier} allowToEdit={allowToEdit}/>
                  )
                })
              }
            </div>
          </CardPanelBody>}
          {!allocationLoader && allocationNoData && (
						<img
							src={noDataAvailable}
							alt="notAvailableImg"
							className="noDataFoundImg"
							style={{width:"20%", marginTop:"0"}}
						/>
					)}
          {allocationLoader && <PulseLoader
            color="#007bff"
            size="20px"
            margin="10px"
            style={{ position: "relative", top: "0vh", left: "45%" }}
          />}
        </CardPanel>
      </div>

      <div className="new-dashboard-statistics-row">
        {
          containerCountData.map((item)=>{
            if(item.DataOf === "Tractor"){
              if(item.STATUS === "Booked"){
                tractorObj["Booked"] = item.Container_Count?item.Container_Count:0
                tractorObj["Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Not Booked"){
                tractorObj["Not Booked"] = item.Container_Count?item.Container_Count:0
                tractorObj["Not Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Approved"){
                tractorObj["Sent for approval"] = item.Container_Count?item.Container_Count:0
                tractorObj["Sent for approval Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Cancelled"){
                tractorObj["Cancelled"] = item.Container_Count?item.Container_Count:0
                tractorObj["Cancelled Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Pending"){
                tractorObj["Approval Pending"] = item.Container_Count?item.Container_Count:0
                tractorObj["Approval Pending Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Hold"){ 
                tractorObj["Hold"] = item.Container_Count?item.Container_Count:0
                tractorObj["Hold Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Total Container Count"){
                tractorObj["Total Container"] = item.Container_Count?item.Container_Count:0
                tractorObj["Total Container Percentage"] = item.Percentage?item.Percentage:0
              }
            }
            if(item.DataOf === "Aggregate"){
              if(item.STATUS === "Booked"){
                aggObj["Booked"] = item.Container_Count?item.Container_Count:0
                aggObj["Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Not Booked"){
                aggObj["Not Booked"] = item.Container_Count?item.Container_Count:0
                aggObj["Not Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Approved"){
                aggObj["Sent for approval"] = item.Container_Count?item.Container_Count:0
                aggObj["Sent for approval Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Cancelled"){
                aggObj["Cancelled"] = item.Container_Count?item.Container_Count:0
                aggObj["Cancelled Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Pending"){
                aggObj["Approval Pending"] = item.Container_Count?item.Container_Count:0
                aggObj["Approval Pending Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Hold"){
                aggObj["Hold"] = item.Container_Count?item.Container_Count:0
                aggObj["Hold Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Total Container Count"){
                aggObj["Total Container"] = item.Container_Count?item.Container_Count:0
                aggObj["Total Container Percentage"] = item.Percentage?item.Percentage:0
              }
            }
            if(item.DataOf === "5M"){
              if(item.STATUS === "Booked"){
                fiveMObj["Booked"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Not Booked"){
                fiveMObj["Not Booked"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Not Booked Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Approved"){
                fiveMObj["Sent for approval"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Sent for approval Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Cancelled"){
                fiveMObj["Cancelled"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Cancelled Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Pending"){
                fiveMObj["Approval Pending"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Approval Pending Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Hold"){
                fiveMObj["Hold"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Hold Percentage"] = item.Percentage?item.Percentage:0
              }
              if(item.STATUS === "Total Container Count"){
                fiveMObj["Total Container"] = item.Container_Count?item.Container_Count:0
                fiveMObj["Total Container Percentage"] = item.Percentage?item.Percentage:0
              }
              
            }
          })
        }
        {
          [tractorObj, aggObj, fiveMObj].map((item)=>{
            return(
              <StatisticsCard containerItem={item} containerCountMonth={containerCountMonth} setContainerCountMonth={setContainerCountMonth} contCountData = {[tractorObj, aggObj, fiveMObj]} containerCountNoData={containerCountNoData} containerCountLoader={containerCountLoader} />
            )
          })
        }
        {/* <StatisticsCard />
        <StatisticsCard /> */}
      </div>
      {/* <div className="new-dashboard-footer">
        <svg
          width="110"
          height="49"
          viewBox="0 0 110 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.79199 9.28809H2.20117V7.92773H4.79199C5.24316 7.92773 5.60775 7.85482 5.88574 7.70898C6.16374 7.56315 6.36654 7.36263 6.49414 7.10742C6.6263 6.84766 6.69238 6.55143 6.69238 6.21875C6.69238 5.9043 6.6263 5.61035 6.49414 5.33691C6.36654 5.05892 6.16374 4.83561 5.88574 4.66699C5.60775 4.49837 5.24316 4.41406 4.79199 4.41406H2.72754V13H1.01172V3.04688H4.79199C5.56217 3.04688 6.21615 3.18359 6.75391 3.45703C7.29622 3.72591 7.70866 4.09961 7.99121 4.57812C8.27376 5.05208 8.41504 5.5944 8.41504 6.20508C8.41504 6.84766 8.27376 7.39909 7.99121 7.85938C7.70866 8.31966 7.29622 8.67285 6.75391 8.91895C6.21615 9.16504 5.56217 9.28809 4.79199 9.28809ZM9.37891 9.38379V9.22656C9.37891 8.69336 9.45638 8.19889 9.61133 7.74316C9.76628 7.28288 9.98958 6.88411 10.2812 6.54688C10.5775 6.20508 10.9375 5.94076 11.3613 5.75391C11.7897 5.5625 12.2728 5.4668 12.8105 5.4668C13.3529 5.4668 13.8359 5.5625 14.2598 5.75391C14.6882 5.94076 15.0505 6.20508 15.3467 6.54688C15.6429 6.88411 15.8685 7.28288 16.0234 7.74316C16.1784 8.19889 16.2559 8.69336 16.2559 9.22656V9.38379C16.2559 9.91699 16.1784 10.4115 16.0234 10.8672C15.8685 11.3229 15.6429 11.7217 15.3467 12.0635C15.0505 12.4007 14.6904 12.665 14.2666 12.8564C13.8428 13.0433 13.362 13.1367 12.8242 13.1367C12.2819 13.1367 11.7965 13.0433 11.3682 12.8564C10.9443 12.665 10.5843 12.4007 10.2881 12.0635C9.99186 11.7217 9.76628 11.3229 9.61133 10.8672C9.45638 10.4115 9.37891 9.91699 9.37891 9.38379ZM11.0264 9.22656V9.38379C11.0264 9.71647 11.0605 10.0309 11.1289 10.3271C11.1973 10.6234 11.3044 10.8831 11.4502 11.1064C11.596 11.3298 11.7829 11.5052 12.0107 11.6328C12.2386 11.7604 12.5098 11.8242 12.8242 11.8242C13.1296 11.8242 13.3939 11.7604 13.6172 11.6328C13.8451 11.5052 14.0319 11.3298 14.1777 11.1064C14.3236 10.8831 14.4307 10.6234 14.499 10.3271C14.5719 10.0309 14.6084 9.71647 14.6084 9.38379V9.22656C14.6084 8.89844 14.5719 8.58854 14.499 8.29688C14.4307 8.00065 14.3213 7.73861 14.1709 7.51074C14.0251 7.28288 13.8382 7.10514 13.6104 6.97754C13.387 6.84538 13.1204 6.7793 12.8105 6.7793C12.5007 6.7793 12.2318 6.84538 12.0039 6.97754C11.7806 7.10514 11.596 7.28288 11.4502 7.51074C11.3044 7.73861 11.1973 8.00065 11.1289 8.29688C11.0605 8.58854 11.0264 8.89844 11.0264 9.22656ZM19.6465 11.3594L21.3555 5.60352H22.4082L22.1211 7.32617L20.3984 13H19.4551L19.6465 11.3594ZM18.6416 5.60352L19.9746 11.3867L20.084 13H19.0312L17.0283 5.60352H18.6416ZM24.0078 11.3184L25.2998 5.60352H26.9062L24.9102 13H23.8574L24.0078 11.3184ZM22.5859 5.60352L24.2744 11.291L24.4863 13H23.543L21.7998 7.31934L21.5127 5.60352H22.5859ZM31.2881 13.1367C30.7412 13.1367 30.2467 13.0479 29.8047 12.8701C29.3672 12.6878 28.9935 12.4349 28.6836 12.1113C28.3783 11.7878 28.1436 11.4072 27.9795 10.9697C27.8154 10.5322 27.7334 10.0605 27.7334 9.55469V9.28125C27.7334 8.70247 27.8177 8.17839 27.9863 7.70898C28.1549 7.23958 28.3896 6.83854 28.6904 6.50586C28.9912 6.16862 29.3467 5.91113 29.7568 5.7334C30.167 5.55566 30.6113 5.4668 31.0898 5.4668C31.6185 5.4668 32.0811 5.55566 32.4775 5.7334C32.874 5.91113 33.2021 6.16178 33.4619 6.48535C33.7262 6.80436 33.9222 7.1849 34.0498 7.62695C34.182 8.06901 34.248 8.55664 34.248 9.08984V9.79395H28.5332V8.61133H32.6211V8.48145C32.612 8.18522 32.5527 7.90723 32.4434 7.64746C32.3385 7.3877 32.1768 7.17806 31.958 7.01855C31.7393 6.85905 31.4476 6.7793 31.083 6.7793C30.8096 6.7793 30.5658 6.83854 30.3516 6.95703C30.1419 7.07096 29.9665 7.2373 29.8252 7.45605C29.6839 7.6748 29.5745 7.93913 29.4971 8.24902C29.4242 8.55436 29.3877 8.89844 29.3877 9.28125V9.55469C29.3877 9.87826 29.431 10.179 29.5176 10.457C29.6087 10.7305 29.7409 10.9697 29.9141 11.1748C30.0872 11.3799 30.2969 11.5417 30.543 11.6602C30.7891 11.7741 31.0693 11.8311 31.3838 11.8311C31.7803 11.8311 32.1335 11.7513 32.4434 11.5918C32.7533 11.4323 33.0221 11.2067 33.25 10.915L34.1182 11.7559C33.9587 11.9883 33.7513 12.2116 33.4961 12.4258C33.2409 12.6354 32.9287 12.8063 32.5596 12.9385C32.195 13.0706 31.7712 13.1367 31.2881 13.1367ZM37.1875 7.01172V13H35.54V5.60352H37.1123L37.1875 7.01172ZM39.4502 5.55566L39.4365 7.08691C39.3363 7.06868 39.2269 7.05501 39.1084 7.0459C38.9945 7.03678 38.8805 7.03223 38.7666 7.03223C38.484 7.03223 38.2357 7.07324 38.0215 7.15527C37.8073 7.23275 37.6273 7.34668 37.4814 7.49707C37.3402 7.6429 37.2308 7.82064 37.1533 8.03027C37.0758 8.23991 37.0303 8.47461 37.0166 8.73438L36.6406 8.76172C36.6406 8.29688 36.6862 7.86621 36.7773 7.46973C36.8685 7.07324 37.0052 6.72461 37.1875 6.42383C37.3743 6.12305 37.6068 5.88835 37.8848 5.71973C38.1673 5.55111 38.4932 5.4668 38.8623 5.4668C38.9626 5.4668 39.0697 5.47591 39.1836 5.49414C39.3021 5.51237 39.391 5.53288 39.4502 5.55566ZM43.6064 13.1367C43.0596 13.1367 42.5651 13.0479 42.123 12.8701C41.6855 12.6878 41.3118 12.4349 41.002 12.1113C40.6966 11.7878 40.4619 11.4072 40.2979 10.9697C40.1338 10.5322 40.0518 10.0605 40.0518 9.55469V9.28125C40.0518 8.70247 40.1361 8.17839 40.3047 7.70898C40.4733 7.23958 40.708 6.83854 41.0088 6.50586C41.3096 6.16862 41.665 5.91113 42.0752 5.7334C42.4854 5.55566 42.9297 5.4668 43.4082 5.4668C43.9368 5.4668 44.3994 5.55566 44.7959 5.7334C45.1924 5.91113 45.5205 6.16178 45.7803 6.48535C46.0446 6.80436 46.2406 7.1849 46.3682 7.62695C46.5003 8.06901 46.5664 8.55664 46.5664 9.08984V9.79395H40.8516V8.61133H44.9395V8.48145C44.9303 8.18522 44.8711 7.90723 44.7617 7.64746C44.6569 7.3877 44.4951 7.17806 44.2764 7.01855C44.0576 6.85905 43.766 6.7793 43.4014 6.7793C43.1279 6.7793 42.8841 6.83854 42.6699 6.95703C42.4603 7.07096 42.2848 7.2373 42.1436 7.45605C42.0023 7.6748 41.8929 7.93913 41.8154 8.24902C41.7425 8.55436 41.7061 8.89844 41.7061 9.28125V9.55469C41.7061 9.87826 41.7493 10.179 41.8359 10.457C41.9271 10.7305 42.0592 10.9697 42.2324 11.1748C42.4056 11.3799 42.6152 11.5417 42.8613 11.6602C43.1074 11.7741 43.3877 11.8311 43.7021 11.8311C44.0986 11.8311 44.4518 11.7513 44.7617 11.5918C45.0716 11.4323 45.3405 11.2067 45.5684 10.915L46.4365 11.7559C46.277 11.9883 46.0697 12.2116 45.8145 12.4258C45.5592 12.6354 45.2471 12.8063 44.8779 12.9385C44.5133 13.0706 44.0895 13.1367 43.6064 13.1367ZM52.3633 11.4688V2.5H54.0176V13H52.5205L52.3633 11.4688ZM47.5508 9.38379V9.24023C47.5508 8.67969 47.6169 8.16927 47.749 7.70898C47.8812 7.24414 48.0726 6.84538 48.3232 6.5127C48.5739 6.17546 48.8792 5.91797 49.2393 5.74023C49.5993 5.55794 50.0049 5.4668 50.4561 5.4668C50.9027 5.4668 51.2946 5.55339 51.6318 5.72656C51.9691 5.89974 52.2562 6.14811 52.4932 6.47168C52.7301 6.79069 52.9193 7.1735 53.0605 7.62012C53.2018 8.06217 53.3021 8.55436 53.3613 9.09668V9.55469C53.3021 10.0833 53.2018 10.5664 53.0605 11.0039C52.9193 11.4414 52.7301 11.8197 52.4932 12.1387C52.2562 12.4577 51.9668 12.7038 51.625 12.877C51.2878 13.0501 50.8936 13.1367 50.4424 13.1367C49.9958 13.1367 49.5924 13.0433 49.2324 12.8564C48.877 12.6696 48.5739 12.4076 48.3232 12.0703C48.0726 11.7331 47.8812 11.3366 47.749 10.8809C47.6169 10.4206 47.5508 9.92155 47.5508 9.38379ZM49.1982 9.24023V9.38379C49.1982 9.72103 49.2279 10.0355 49.2871 10.3271C49.3509 10.6188 49.4489 10.8763 49.5811 11.0996C49.7132 11.3184 49.8841 11.4915 50.0938 11.6191C50.3079 11.7422 50.5632 11.8037 50.8594 11.8037C51.2331 11.8037 51.5407 11.7217 51.7822 11.5576C52.0238 11.3936 52.2129 11.1725 52.3496 10.8945C52.4909 10.612 52.5866 10.2975 52.6367 9.95117V8.71387C52.6094 8.44499 52.5524 8.19434 52.4658 7.96191C52.3838 7.72949 52.2721 7.52669 52.1309 7.35352C51.9896 7.17578 51.8141 7.03906 51.6045 6.94336C51.3994 6.8431 51.1556 6.79297 50.873 6.79297C50.5723 6.79297 50.3171 6.85677 50.1074 6.98438C49.8978 7.11198 49.7246 7.28743 49.5879 7.51074C49.4557 7.73405 49.3577 7.99382 49.2939 8.29004C49.2301 8.58626 49.1982 8.90299 49.1982 9.24023ZM63.123 8.50195H60.5869L60.5732 7.25098H62.7881C63.1618 7.25098 63.4785 7.19629 63.7383 7.08691C64.0026 6.97298 64.2031 6.8112 64.3398 6.60156C64.4766 6.38737 64.5449 6.12988 64.5449 5.8291C64.5449 5.49642 64.4811 5.22526 64.3535 5.01562C64.2259 4.80599 64.0299 4.65332 63.7656 4.55762C63.5059 4.46191 63.1732 4.41406 62.7676 4.41406H61.1064V13H59.3906V3.04688H62.7676C63.3145 3.04688 63.8021 3.09928 64.2305 3.2041C64.6634 3.30892 65.0303 3.47298 65.3311 3.69629C65.6364 3.91504 65.8665 4.19303 66.0215 4.53027C66.181 4.86751 66.2607 5.26855 66.2607 5.7334C66.2607 6.14355 66.1628 6.51953 65.9668 6.86133C65.7708 7.19857 65.4814 7.47428 65.0986 7.68848C64.7158 7.90267 64.2396 8.03027 63.6699 8.07129L63.123 8.50195ZM63.0479 13H60.0469L60.8193 11.6396H63.0479C63.4352 11.6396 63.7588 11.5758 64.0186 11.4482C64.2783 11.3161 64.472 11.1361 64.5996 10.9082C64.7318 10.6758 64.7979 10.4046 64.7979 10.0947C64.7979 9.77116 64.7409 9.49089 64.627 9.25391C64.513 9.01237 64.333 8.8278 64.0869 8.7002C63.8408 8.56803 63.5195 8.50195 63.123 8.50195H61.1953L61.209 7.25098H63.7178L64.1074 7.72266C64.6543 7.74089 65.1032 7.86165 65.4541 8.08496C65.8096 8.30827 66.0739 8.59766 66.2471 8.95312C66.4202 9.30859 66.5068 9.69141 66.5068 10.1016C66.5068 10.735 66.3678 11.266 66.0898 11.6943C65.8164 12.1227 65.4222 12.4486 64.9072 12.6719C64.3923 12.8906 63.7725 13 63.0479 13ZM70.2188 12.1934L72.2285 5.60352H73.9922L71.0254 14.1279C70.957 14.3102 70.8682 14.5085 70.7588 14.7227C70.6494 14.9368 70.5059 15.1396 70.3281 15.3311C70.1549 15.527 69.9385 15.6842 69.6787 15.8027C69.4189 15.9258 69.1045 15.9873 68.7354 15.9873C68.5895 15.9873 68.4482 15.9736 68.3115 15.9463C68.1794 15.9235 68.054 15.8984 67.9355 15.8711L67.9287 14.6133C67.9743 14.6178 68.029 14.6224 68.0928 14.627C68.1611 14.6315 68.2158 14.6338 68.2568 14.6338C68.5303 14.6338 68.7581 14.5996 68.9404 14.5312C69.1227 14.4674 69.2708 14.3626 69.3848 14.2168C69.5033 14.071 69.6035 13.875 69.6855 13.6289L70.2188 12.1934ZM69.084 5.60352L70.8408 11.1406L71.1348 12.877L69.9932 13.1709L67.3066 5.60352H69.084Z"
            fill="#DCDCDC"
          />
          <path
            d="M27.5679 46.8576H13.4782C6.53526 46.8576 0.803009 41.6462 0.803009 34.365C0.803009 27.1867 6.29436 21.8044 13.4432 21.8044C20.3161 21.8044 25.9105 27.0488 25.9105 34.0214C25.9105 38.163 23.942 42.2346 20.3162 43.8908V43.9608H27.5679V46.8576ZM22.3875 34.1572C22.3875 28.9807 18.5536 24.9091 13.3382 24.9091C8.2257 24.9091 4.3239 29.0157 4.3239 34.0893C4.3239 39.4386 8.0198 43.7509 13.3382 43.7509C18.6937 43.7509 22.3875 39.5065 22.3875 34.1572Z"
            fill="#1D3E69"
          />
          <path
            d="M28.371 47.6601H13.4782C5.91962 47.6601 0 41.819 0 34.365C0 26.7464 5.77961 21.0021 13.4432 21.0021C20.8844 21.0021 26.7135 26.7217 26.7135 34.0214C26.7135 37.7248 25.2722 41.066 22.894 43.1584H28.371V47.6601ZM13.4432 22.6048C6.69587 22.6048 1.60602 27.6599 1.60602 34.363C1.60602 41.0269 6.71028 46.0532 13.4782 46.0532H26.7649V44.7591H19.5131V43.3724L19.9826 43.1584C23.0958 41.7367 25.1074 38.1486 25.1074 34.0194C25.1074 27.6187 19.9847 22.6048 13.4432 22.6048ZM13.3403 44.5534C7.7439 44.5534 3.52295 40.0538 3.52295 34.0893C3.52295 28.4911 7.83449 24.1067 13.3403 24.1067C18.9572 24.1067 23.1926 28.4273 23.1926 34.1572C23.1926 40.0846 18.9572 44.5534 13.3403 44.5534ZM13.3403 25.7115C8.73634 25.7115 5.12897 29.3922 5.12897 34.0893C5.12897 39.1403 8.65809 42.9486 13.3403 42.9486C18.1171 42.9486 21.5845 39.2514 21.5845 34.1572C21.5845 29.3429 18.041 25.7115 13.3403 25.7115Z"
            fill="#1D3E69"
          />
          <path
            d="M35.7669 22.4237V37.4017C35.7669 40.4385 37.2864 44.3723 41.9151 44.3723C46.5437 44.3723 48.0632 40.4385 48.0632 37.4017V22.4237H51.3782V37.9181C51.3782 43.5781 47.2685 47.4769 41.9151 47.4769C36.5617 47.4769 32.4519 43.5781 32.4519 37.9181V22.4237H35.7669Z"
            fill="#1D3E69"
          />
          <path
            d="M41.915 48.2814C35.9666 48.2814 31.6489 43.9238 31.6489 37.9202V21.6213H36.5699V37.4017C36.5699 40.2472 37.97 43.5699 41.915 43.5699C45.8601 43.5699 47.2602 40.2472 47.2602 37.4017V21.6213H52.1812V37.9182C52.1812 43.9238 47.8635 48.2814 41.915 48.2814ZM33.2549 23.2261V37.9182C33.2549 42.9918 36.8973 46.6745 41.915 46.6745C46.9328 46.6745 50.5731 42.9938 50.5731 37.9182V23.2261H48.8642V37.3997C48.8642 41.2697 46.7146 45.1726 41.913 45.1726C37.1114 45.1726 34.9618 41.2676 34.9618 37.3997V23.2261H33.2549Z"
            fill="#1D3E69"
          />
          <path
            d="M58.2902 22.4237H61.6052V43.7509H72.8288V46.8576H58.2902V22.4237Z"
            fill="#2DC1DB"
          />
          <path
            d="M73.6339 47.66H57.4872V21.6213H62.4083V42.9485H73.6339V47.66ZM59.0953 46.0553H72.0279V44.5554H60.8043V23.2261H59.0953V46.0553Z"
            fill="#2DC1DB"
          />
          <path
            d="M74.4698 34.6407C74.4698 27.3944 79.7532 21.8024 87.213 21.8024C94.6728 21.8024 99.9562 27.3924 99.9562 34.6407C99.9562 41.889 94.6728 47.479 87.213 47.479C79.7532 47.479 74.4698 41.8869 74.4698 34.6407ZM96.4353 34.6407C96.4353 29.2914 92.8094 24.9091 87.213 24.9091C81.6166 24.9091 77.9928 29.2914 77.9928 34.6407C77.9928 39.99 81.6187 44.3723 87.2151 44.3723C92.8114 44.3723 96.4353 39.99 96.4353 34.6407Z"
            fill="#2DC1DB"
          />
          <path
            d="M87.2151 48.2814C79.4918 48.2814 73.6689 42.4177 73.6689 34.6407C73.6689 26.8636 79.4939 21 87.2151 21C94.9363 21 100.761 26.8636 100.761 34.6407C100.761 42.4177 94.9384 48.2814 87.2151 48.2814ZM87.2151 22.6048C80.2969 22.6048 75.275 27.666 75.275 34.6407C75.275 41.6153 80.2969 46.6766 87.2151 46.6766C94.1333 46.6766 99.1552 41.6153 99.1552 34.6407C99.1552 27.666 94.1333 22.6048 87.2151 22.6048ZM87.2151 45.1747C81.4067 45.1747 77.1898 40.7451 77.1898 34.6407C77.1898 28.5363 81.4067 24.1067 87.2151 24.1067C93.0235 24.1067 97.2404 28.5363 97.2404 34.6407C97.2404 40.7451 93.0235 45.1747 87.2151 45.1747ZM87.2151 25.7115C82.3373 25.7115 78.7979 29.4663 78.7979 34.6407C78.7979 39.8151 82.3373 43.5699 87.2151 43.5699C92.0929 43.5699 95.6323 39.8151 95.6323 34.6407C95.6323 29.4663 92.0929 25.7115 87.2151 25.7115Z"
            fill="#2DC1DB"
          />
          <path
            d="M105.882 22.4237H109.197V46.8556H105.882V22.4237Z"
            fill="#2DC1DB"
          />
          <path
            d="M110 47.66H105.079V21.6213H110V47.66ZM106.685 46.0553H108.394V23.2261H106.685V46.0553Z"
            fill="#2DC1DB"
          />
          <path
            d="M19.4658 43.1646L11.4418 47.6682H28.3689V43.1646H19.4658Z"
            fill="#2DC1DB"
          />
        </svg>
      </div> */}
    </div>
  );
}

export default NewDashboard;
